import { createAction, props } from '@ngrx/store';

export const loadAccountTypes = createAction('[AccountTypes] Load AccountTypes');

export const loadAccountTypesSuccess = createAction('[AccountTypes] Load AccountTypes Success', props<{ response: any }>());

export const loadAccountTypesFailure = createAction('[AccountTypes] Load AccountTypes Failure', props<{ error: Error | any }>());